import React, { useState, useEffect } from 'react'
import { Form, Button, Container, Row, Col, Modal, Nav, BreadcrumbItem, Breadcrumb, Table } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useGetformMutation } from '../../slices/formApiSlice'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useGetEmployeeListMutation, useGetOptionsMutation } from '../../slices/commonApiSlice'
import { parseOptionsData } from '../../utils/parseOptionsData'
import { parseUserInfo } from '../../utils/parseUtil'
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { useGetGratuityReportMutation } from '../../slices/adminApiSlice'

const GratuityReport = () => {
    const [month, setMonth] = useState("")
    const [year, setYear] = useState("")
    const [empType, setEmpType] = useState("")
    const [empName, setEmpName] = useState("")
    const [department, setDepartment] = useState("")
    const [designation, setDesignation] = useState("")
    const [empCode, setEmpCode] = useState("")
    const [activeType, setActiveType] = useState("0")
    const [language, setLanguage] = useState("0")
    const [showModal, setShowModal] = useState(false)
    const [pdfUrl, setPdfUrl] = useState("")
    const [employeeSuggestions, setEmployeeSuggestions] = useState([])
    const [selectedEmpCode, setSelectedEmpCode] = useState("")
    const [submittedData, setSubmittedData] = useState(null);




    const { userInfo } = useSelector((state) => state.auth)

    const [getGratuityReport, { isLoading }] = useGetGratuityReportMutation()
    const [getOptions, { isLoading: getOptionsLoading }] = useGetOptionsMutation()
    const [getEmpName, { isLoading: getEmpNameLoading }] = useGetEmployeeListMutation()

    const [employeeTypes, setEmployeeTypes] = useState([])
    const [designations, setDesignations] = useState([])
    const [departments, setDepartments] = useState([])
    const [ReqRptType, setReqRptType] = useState('1')
    const [ReqPayDate, setReqPayDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // Format as 'yyyy-mm-dd'
    });

    useEffect(() => {
        const now = new Date()
        const currentYear = now.getFullYear()
        const currentMonth = now.getMonth() + 1
        const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1

        setYear(currentYear.toString())
        setMonth(previousMonth.toString())

        // Fetch options data on component load
        const fetchOptions = async () => {
            try {
                const reqCompanyCode = userInfo[13]?.InfoField || '1' // Default to '1' if not available

                const formData = new FormData()
                formData.append('title', 'GetEmployeeMasterDataList')
                formData.append('ReqCompanyCode', reqCompanyCode)

                const res = await getOptions(formData)

                const parsedOptions = parseUserInfo(res)
                const parsedData = parseOptionsData(parsedOptions)

                console.log(parsedData, "12")

                if (parsedData) {
                    setEmployeeTypes(parsedData.employeeTypes)
                    setDesignations(parsedData.designations)
                    setDepartments(parsedData.departments)
                } else {
                    toast.error('Failed to load options')
                }
            } catch (err) {
                console.error('Error fetching options:', err)
                toast.error('Error fetching options')
            }
        }

        fetchOptions()
    }, [getOptions, userInfo])

    const handleEmployeeSearch = async (input) => {
        if (input.length < 3) {
            setEmployeeSuggestions([]) // Clear suggestions if input is less than 3 characters
            return
        }

        try {
            const reqCompanyCode = userInfo[13]?.InfoField || '1' // Default to '1' if not available
            const formData = new FormData()
            formData.append('title', 'GetEmployeeList')
            formData.append('ReqCompanyCode', reqCompanyCode)
            formData.append('ReqSearchStr', input)

            const res = await getEmpName(formData)
            const parsedData = parseUserInfo(res)

            if (parsedData && parsedData.length > 0) {
                const employeeList = JSON.parse(parsedData[0].JSONData1)
                setEmployeeSuggestions(employeeList)
            } else {
                setEmployeeSuggestions([])
                toast.error('No employees found')
            }
        } catch (err) {
            console.error('Error fetching employee list:', err)
            toast.error('Error fetching employee list')
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault()

        const reqCompanyCode = userInfo[13]?.InfoField
        // const reqEmpCode = userInfo[1]?.InfoField

        const [year, month, day] = ReqPayDate.split('-')
        const formattedDate = (`${day}-${month}-${year}`)

        const formData = new FormData()
        formData.append('title', 'GetGratuityReports')
        formData.append('description', 'GetForm14ForEmployee')
        formData.append('ReqPayDate', formattedDate)
        formData.append('ReqEmpType', empType)
        formData.append('ReqActiveType', activeType)
        formData.append('ReqEmpCode', empCode)
        formData.append('ReqCompanyCode', reqCompanyCode)
        formData.append('ReqRptType', ReqRptType)

        for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`)
        }


        // Store form data in state to display in the table
        setSubmittedData({
            title: 'GetGratuityReports',
            description: 'GetForm14ForEmployee',
            payDate: formattedDate,
            empType,
            activeType,
            empCode: empCode,
            companyCode: reqCompanyCode,
            ReqRptType,
        });
    



        try {
            const res = await getGratuityReport(formData)

            const parsedData = parseUserInfo(res)

            if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
                const data = parsedData[0]

                if (data.ErrorCode === '0') {
                    let pdfPath = data.JSONData1

                    if (pdfPath.startsWith('/api/WebServiceCommonReports.aspx/')) {
                        pdfPath = pdfPath.replace('/api/WebServiceCommonReports.aspx/', '/')
                    }

                    const backendUrl = process.env.REACT_APP_URL
                    const pdfUrl = `${backendUrl}${pdfPath}`

                    setPdfUrl(pdfUrl)
                    setShowModal(true)
                } else {
                    toast.error(data.ErrorMessage || 'An error occurred')
                }
            } else {
                toast.error('Failed to parse user info')
            }
        } catch (err) {
            console.error('Error submitting data:', err)
            toast.error(err?.data?.message || 'Error submitting data')
        }
    }

    return (
        <>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Nav.Link as={Link} to="/dashboard" className='text-success text-decoration-none'>
                        Dashboard
                    </Nav.Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    Gratuity Report
                </BreadcrumbItem>
            </Breadcrumb>
            <Container className="form-container">
                <h4 className="text-center">Gratuity Report</h4>
                <Form className="border p-4 rounded bg-light mb-4" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="empName">
                                <Form.Label>Employee Name</Form.Label>
                                <Typeahead
                                    id="empName-typeahead"
                                    onInputChange={(input) => {
                                        setEmpName(input)
                                        handleEmployeeSearch(input)
                                    }}
                                    onChange={(selected) => {
                                        if (selected.length > 0) {
                                            setEmpName(selected[0].EmployeeName)
                                            setSelectedEmpCode(selected[0].Empcode) // Save the employee code
                                            setEmpCode(selected[0].Empcode)
                                        }
                                    }}
                                    options={employeeSuggestions}
                                    labelKey="EmployeeName"
                                    placeholder="Choose an employee..."
                                    selected={empName ? [{ EmployeeName: empName }] : []}
                                    className="form-control-hover"
                                    minLength={3}
                                />
                            </Form.Group>

                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <Form.Group controlId="empCode" className="mb-3">
                                <Form.Label>Employee Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Employee Code"
                                    value={empCode}
                                    onChange={(e) => setEmpCode(e.target.value)}
                                    className="form-control-hover"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group controlId="empType">
                                <Form.Label>Employee Type</Form.Label>
                                <Typeahead
                                    id="empType-typeahead"
                                    onChange={(selected) => setEmpType(selected[0])}
                                    options={employeeTypes}
                                    placeholder="Choose an employee type..."
                                    selected={empType ? [empType] : []}
                                    className="form-control-hover"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="date">
                                <Form.Label>Active Type</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={activeType}
                                    onChange={(e) => setActiveType(e.target.value)}
                                    className="form-control-hover"
                                >
                                    <option value="0">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Dropped</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="ReqRptType">
                                <Form.Label>Report Type</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={ReqRptType}
                                    onChange={(e) => setReqRptType(e.target.value)}
                                    className="form-control-hover"
                                >
                                    <option value="0">Working Day Wise</option>
                                    <option value="1" selected >Working Date wise</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="ReqPayDate" className="mb-3">
                                <Form.Label>Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Date"
                                    value={ReqPayDate}
                                    onChange={(e) => setReqPayDate(e.target.value)}
                                    className="form-control-hover"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <Button
                                type="submit"
                                variant="primary"
                                className="px-4"
                                disabled={isLoading || getOptionsLoading}
                            >
                                {isLoading || getOptionsLoading ? 'Loading...' : 'Print'}
                            </Button>
                        </Col>
                    </Row>
                </Form>

                {submittedData && (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Pay Date</th>
                                <th>Employee Type</th>
                                <th>Active Type</th>
                                <th>Employee Code</th>
                                <th>Company Code</th>
                                <th>Report Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{submittedData.title}</td>
                                <td>{submittedData.description}</td>
                                <td>{submittedData.payDate}</td>
                                <td>{submittedData.empType}</td>
                                <td>{submittedData.activeType}</td>
                                <td>{submittedData.empCode}</td>
                                <td>{submittedData.companyCode}</td>
                                <td>{submittedData.ReqRptType}</td>
                            </tr>
                        </tbody>
                    </Table>
                )}



                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Salary Slip PDF</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            src={pdfUrl}
                            width="100%"
                            height="500px"
                            title="Salary Slip PDF"
                        ></iframe>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    )
}

export default GratuityReport
